export enum KsefReceivingSubjectRole {
    Seller = 'Seller',
    Buyer = 'Buyer',
    Other = 'Other',
    Authorized = 'Authorized'
}
